function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.333 4H6.667A2.675 2.675 0 004 6.667v18.666C4 26.8 5.2 28 6.667 28h18.666C26.8 28 28 26.8 28 25.333V6.667C28 5.2 26.8 4 25.333 4zm-12 18.667l-6.666-6.41 1.866-1.796 4.8 4.616 10.134-9.744 1.866 1.795-12 11.539z",
  fill: "#B8C3D9"
});

var SvgIconCheckboxDisabled = function SvgIconCheckboxDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS4zMzMzIDRINi42NjY2N0M1LjIgNCA0IDUuMiA0IDYuNjY2NjdWMjUuMzMzM0M0IDI2LjggNS4yIDI4IDYuNjY2NjcgMjhIMjUuMzMzM0MyNi44IDI4IDI4IDI2LjggMjggMjUuMzMzM1Y2LjY2NjY3QzI4IDUuMiAyNi44IDQgMjUuMzMzMyA0Wk0xMy4zMzM0IDIyLjY2NjdMNi42NjY3NSAxNi4yNTY0TDguNTMzNDEgMTQuNDYxNUwxMy4zMzM0IDE5LjA3NjlMMjMuNDY2NyA5LjMzMzMzTDI1LjMzMzQgMTEuMTI4MkwxMy4zMzM0IDIyLjY2NjdaIiBmaWxsPSIjQjhDM0Q5Ii8+Cjwvc3ZnPgo=";
export { SvgIconCheckboxDisabled as ReactComponent };